var _module_exports ="<div class=\"padding-sm\">\n    <div ui-view></div>\n</div>";;
var path = '/app/Main/selfAccessRequest/SelfAccessRequest.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;